module.exports = __webpack_public_path__ + "static/direct-graph-loop-38a68b4a791d5fd61133f78cc4e60861.svg";